/// <reference path="../../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface ICreatePdfSettingsModalControllerScope extends IBaseModalControllerScope {
        workflowBlock: models.CreatePdfWorkflowBlock;
        processConfigId: string;
        isReadonly: boolean;
        addNewPdfSection(): void; 
        deleteSection(index: number): void; 
        pdfBindings: Wars.Domain.Model.PdfBinding[];
        documentFields: Wars.Domain.Model.Field[];
        documentProcessDataVariables: Wars.Domain.Model.SchemaProperty[];
        isSectionTypePdfBinding(sectionType: number): boolean;
        isSectionTypeStaticDocument(sectionType: number): boolean;
        isSectionTypeUserDefinedDocument(sectionType: number): boolean;
        isSectionTypeFormDocument(sectionType: number): boolean;
        isSectionTypeProcessVariableDocument(sectionType: number): boolean;
        filterManagedSections(managedForm: any): void;
        managedForms: any[];
        managedSections: any;
        calculations: Wars.Domain.Model.Calculations.Calculation[];
        conditions: Wars.Domain.Model.Conditions.Condition[];
        staticDocuments: Wars.Domain.Model.StaticDocument[];
        onDragOver($event: any): void;
        onDrop($event: any): void;
        schemaProperty: Wars.Domain.Model.SchemaProperty;
        codeGroups: Wars.Domain.Model.Codes.CodeGroup[];
        systemCodes: Wars.Domain.Model.Codes.SystemCode[];
    }

    export class CreatePdfSettingsModalController extends BaseModalController {
        scope: ICreatePdfSettingsModalControllerScope;
        private processConfigId: string;

        constructor(
            $scope: ICreatePdfSettingsModalControllerScope,
            private pdfBindingService: services.PdfBindingService,
            private processConfigurationService: services.ProcessConfigurationService,
            private formService: services.FormService,
            private treeService: services.TreeService,
            private schemaPropertyService: services.SchemaPropertyService,
            private objectSchemaService: services.ObjectSchemaService,
            private calculationService: services.CalculationService,
            private manageStaticDocumentService: services.ManageStaticDocumentsService,
            private systemLevelService: services.SystemLevelService,
            private conditionService: services.ConditionService,
            private manageCodeService: services.ManageSystemCodesService,
            workflowBlock: models.CreatePdfWorkflowBlock,
            processConfigId: string,
            isReadonly: boolean,
            close: any) {
            super($scope, close);
            this.scope = $scope;
            this.scope.workflowBlock = workflowBlock;
            this.scope.isReadonly = isReadonly;
            this.scope.processConfigId = processConfigId;

            this.scope.addNewPdfSection = () => this.addNewPdfSection();
            this.scope.deleteSection = (index: number) => this.deleteSection(index);

            this.scope.isSectionTypePdfBinding = (sectionType) => this.isSectionTypePdfBinding(sectionType);
            this.scope.isSectionTypeStaticDocument = (sectionType) => this.isSectionTypeStaticDocument(sectionType);
            this.scope.isSectionTypeUserDefinedDocument = (sectionType) => this.isSectionTypeUserDefinedDocument(sectionType);
            this.scope.isSectionTypeFormDocument = (sectionType) => this.isSectionTypeFormDocument(sectionType);
            this.scope.isSectionTypeProcessVariableDocument = (sectionType) => this.isSectionTypeProcessVariableDocument(sectionType);
            this.scope.filterManagedSections = (managedForm) => this.filterManagedSections(managedForm);

            this.processConfigId = processConfigId;
            this.loadPdfBindings();
            this.loadManagedDocuments();
            this.scope.managedForms = [];
            this.scope.managedSections = [];
            this.scope.staticDocuments = [];

            this.scope.onDragOver = ($event: any) => this.onDragOverInternal($event);
            this.scope.onDrop = ($event: any) => this.onDropInternal($event);

            if (this.scope.workflowBlock.createPdfDto.resultSchemaPropertyId) {
                this.schemaPropertyService
                    .getSchemaProperty(this.scope.workflowBlock.createPdfDto.resultSchemaPropertyId).then(
                        (schemaProperty) => this.scope.schemaProperty = schemaProperty);
            }

            calculationService.getAllCalculations(processConfigId).then(
                (calculations) => {
                    this.scope.calculations = calculations;
                });

            this.conditionService.getAllConditions(processConfigId).then(
                (conditions) => {
                    this.scope.conditions = conditions;
                });

            this.manageStaticDocumentService.getStaticDocumentsForProcessConfiguration(this.processConfigId).then(
                (documents) => {
                    this.scope.staticDocuments = this.scope.staticDocuments.concat(documents);
                });

            this.systemLevelService.getSystemLevelStaticDocuments().then(
                (systemLevel) => {
                    this.scope.staticDocuments = this.scope.staticDocuments.concat(systemLevel.myStaticDocuments);
                });

            this.systemLevelService.getSystemLevelDocumentConfiguration().then(
                (sysLevel) => {
                    this.scope.systemCodes = [];
                    if (sysLevel.systemDocumentConfiguration &&
                        sysLevel.systemDocumentConfiguration.documentTypeCodeGroup &&
                        sysLevel.systemDocumentConfiguration.documentTypeCodeGroup.codes) {
                        this.scope.systemCodes = Enumerable
                            .from(sysLevel.systemDocumentConfiguration.documentTypeCodeGroup.codes)
                            .where(i => i.isActive).toArray();
                    }
                });

            this.systemLevelService.getSystemLevelCodes().then(
                (systemLevel) => {
                    this.scope.codeGroups = systemLevel.myCodeGroups;
                    this.manageCodeService.getAllCodesForProcessConfiguration(this.processConfigId).then(
                        (codeGroups) => {
                            this.scope.codeGroups = this.scope.codeGroups.concat(codeGroups);
                        });
                });

            this.formService.getFormFields(this.scope.processConfigId,
                Wars.Domain.Model.Codes.Enums.VariableType.Document).then(
                (fields) => {
                    this.scope.documentFields = fields;
                });

            this.processConfigurationService.getById(processConfigId).then(
                (processConfiguration) => {
                    if (processConfiguration.processDataSchema_id) {
                        this.objectSchemaService.getObjectSchemaExpanded(processConfiguration.processDataSchema_id).then(
                            (objectSchema) => {
                                var topLevelDocuments = Enumerable.from(objectSchema.properties)
                                    .where(i => i.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Document)
                                    .toArray();

                                var listDocuments = Enumerable.from(objectSchema.properties)
                                    .where(i => i.typeSchema !== null)
                                    .selectMany(i => i.typeSchema.properties)
                                    .where(i => i.propertyType === Wars.Domain.Model.Codes.Enums.VariableType.Document)
                                    .toArray();

                                this.scope.documentProcessDataVariables = topLevelDocuments.concat(listDocuments);
                            });
                    }
                });
        }

        private addNewPdfSection(): void {
            var newSection = 
            {
                sectionIndex: this.scope.workflowBlock.createPdfDto.myPdfSections.length + 1
            };
            this.scope.workflowBlock.createPdfDto.myPdfSections.push(<Wars.Domain.Model.Dtos.PdfSectionDto>newSection);
        }

        private deleteSection(index: number) {
            this.scope.workflowBlock.createPdfDto.myPdfSections.splice(index, 1);
        }

        private loadPdfBindings() : void {
            if (this.processConfigId) {
                this.pdfBindingService.getPdfBindings(this.processConfigId).then(
                    (pdfBindings) => this.scope.pdfBindings = pdfBindings);
            }
        }

        private loadManagedDocuments(): void {
            if (this.processConfigId) {
                this.formService.getFormWithSection(this.processConfigId)
                    .then((forms) => {
                        forms.forEach(f => {
                            var documentSections = Enumerable.from(f.myManageSections)
                                .where(i => i.manageSectionType === Wars.Domain.Model.Codes.Enums.ManageSectionType.Documents)
                                .toArray();
                            if (documentSections.length > 0) {
                                var form = {
                                    id: f.id,
                                    name: f.name,
                                    myManageSections: documentSections
                                }
                                this.scope.managedForms.push(form);

                                if (this.scope.workflowBlock.createPdfDto.myPdfSections.length > 0) {
                                    var pdfSection = Enumerable
                                        .from(this.scope.workflowBlock.createPdfDto.myPdfSections)
                                        .where(i => i.form_id === form.id)
                                        .firstOrDefault();
                                    if (pdfSection !== null) {
                                        this.filterManagedSections(form.id);
                                    }
                                }
                            }
                        });
                    });
            }
        }

        private filterManagedSections(managedForm: any): void {
            this.scope.managedSections = Enumerable.from(this.scope.managedForms)
                .where(i => i.id === managedForm)
                .first().myManageSections;
        }

        private isSectionTypePdfBinding(sectionType: number): boolean {
            return sectionType === Wars.Domain.Model.Codes.Enums.PdfSectionType.PdfBinding;
        }

        private isSectionTypeStaticDocument(sectionType: number): boolean {
            return sectionType === Wars.Domain.Model.Codes.Enums.PdfSectionType.StaticDocument;
        }

        private isSectionTypeUserDefinedDocument(sectionType: number): boolean {
            return sectionType === Wars.Domain.Model.Codes.Enums.PdfSectionType.UserSelectedDocuments;
        }

        private isSectionTypeFormDocument(sectionType: number): boolean {
            return sectionType === Wars.Domain.Model.Codes.Enums.PdfSectionType.FormDocument;
        }

        private isSectionTypeProcessVariableDocument(sectionType: number): boolean {
            return sectionType === Wars.Domain.Model.Codes.Enums.PdfSectionType.ProcessVariableDocument;
        }

        public onDragOverInternal($event: any): void {
            //var treeConfig = this.treeService.getTreeConfigurationItem();
        }

        public onDropInternal($event: any): void {
            var treeConfig = this.treeService.getTreeConfigurationItem();

            this.scope.workflowBlock.createPdfDto.resultSchemaPropertyId = treeConfig.schemaPropertyId;
            this.schemaPropertyService.getSchemaProperty(treeConfig.schemaPropertyId).then(
                (schemaProperty) => this.scope.schemaProperty = schemaProperty);

            $event.preventDefault();
            $event.stopPropagation();

            this.treeService.clearDragValue();
        }
    }
}

warsApp.registerController("CreatePdfSettingsModalController",
    [
        "$scope", "pdfBindingService", "processConfigurationService", "formService", "treeService", "schemaPropertyService",
        "objectSchemaService", "calculationService", "manageStaticDocumentsService", "systemLevelService",
        "conditionService", "manageSystemCodesService", "workflowBlock", "processConfigId", "isReadonly", "close"
    ]);